/**
 @ngdoc service
 @name mapVendorTileService
 @description
 factory used by mapTilesJsonData.js to construct tile data into tileData object
 */

(function() {
    'use strict';

    var mapVendorTileService = function(tileDataFactory) {

       var map = function(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData){
           var self = this;

           // Assigning tile factory function with parameters to variable
           var tileFactory = new tileDataFactory.constructTileData(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData);

           // Adding labels to column structured data
           tileFactory.addFieldToColumn1(tileFactory.field.newField('id'));

           tileFactory.addFieldToColumn1(tileFactory.field.newRankedInactiveFieldAjax(
               'phoneNo',
               [['phoneStrike', 'phoneStrike'], []],
               'actionLogURI','logPhoneCall'
           ));

           tileFactory.addFieldToColumn2(tileFactory.field.newAddressField('address'));

           if(rawTileData.distanceFromSearch != null || rawTileData.distanceFromSearch != undefined) {
               tileFactory.addFieldToColumn2(tileFactory.field.newField('distanceFromSearch'));
           }

           if(rawTileData.attachedManager > 0) {
               tileFactory.addFieldToColumn4(tileFactory.field.newLinkField('attachedManager', 'attachedManagerURI'));
           }
           else{
               tileFactory.addFieldToColumn4(tileFactory.field.newField('attachedManager'));
           }

           tileFactory.addStatus(tileFactory.status.newStatus('vendorStatus', [tileFactory.LOOKUP_VALUE.VENDOR_STATUS_ACTIVE], [], [tileFactory.LOOKUP_VALUE.VENDOR_STATUS_DRAFT]));

           return tileFactory.tileData;
       };

       return {
           map : map
       };
   };

    mapVendorTileService.$inject = ['tileDataFactory'];
    angular.module('app').factory('mapVendorTileService', mapVendorTileService);
}());
